var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseSingletonService, Singleton } from '~/services/service.base';
import { makeObservable, observable, runInAction } from 'mobx';
import { MobxQuery } from '~/tools/mobx.query';
import { api } from '~/tools/api';
import { EApiUrl } from '~/tools/api/types';
import { plainToInstance } from 'class-transformer';
import { SearchTemplateModel } from '~/models/search.template.model';
export let ServiceSearchTemplate = class ServiceSearchTemplate extends BaseSingletonService {
    templates;
    communityId;
    constructor() {
        super();
        makeObservable(this);
        this.setCommunityId(17);
        this.getItems();
    }
    setCommunityId(communityId) {
        this.communityId = communityId;
    }
    convertToOptions(templates) {
        return (templates?.map(template => {
            return {
                id: template.id,
                label: `${template.name}${template.name && template.cdate ? ' - ' : ''}${template.cdate}`,
                value: template.name,
            };
        }) || []);
    }
    getItems(params) {
        return new MobxQuery({
            queryFn: (() => api
                .get(`${EApiUrl.communities}/${this.communityId}/${EApiUrl.searchTemplates}`, params)
                .then(response => {
                const comparator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
                runInAction(() => {
                    this.templates = Array.isArray(response.data)
                        ? plainToInstance(SearchTemplateModel, response.data).sort((a, b) => comparator.compare(a.name, b.name))
                        : [];
                });
            })),
        }).query();
    }
};
__decorate([
    observable,
    __metadata("design:type", Array)
], ServiceSearchTemplate.prototype, "templates", void 0);
ServiceSearchTemplate = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [])
], ServiceSearchTemplate);
